import { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppBranding } from '../../types/appBranding';

import React from 'react';
import {
	selectAuthenticationContext,
	useSelectFeaturesLoaded,
} from '../../selectors';
import { setIsLoading as setLoadingAction } from '../../actions/app.actions';
import { useSettings } from '../../contexts/Settings';
import { useSiteConfig } from '../../contexts';
import { selectSubscriptionUsage } from '../../hooks/accountSubscriptionsHooks/selectors';
import { UnauthorizedLoadingPage } from '../../pages/UnauthorizedLoadingPage';

interface LoadingContext {
	isLoading: boolean;
}

export const LoadingContext = React.createContext<LoadingContext>({
	isLoading: true,
});

export const useLoadingContext = () => useContext(LoadingContext);

interface LoadingProviderProps {
	children: React.ReactElement;
	branding?: AppBranding;
}

export const LoadingProvider = ({
	children,
	branding,
}: LoadingProviderProps) => {
	const { configLoaded } = useSiteConfig();
	const { isInitializing } = useSelector(selectAuthenticationContext);
	const featuresLoaded = useSelectFeaturesLoaded();
	const { settingsLoaded } = useSettings();
	const { initialized: subscriptionsInitialized } = useSelector(
		selectSubscriptionUsage,
	);
	const dispatch = useDispatch();
	const isApplicationLoading =
		!configLoaded ||
		isInitializing ||
		!featuresLoaded ||
		!settingsLoaded ||
		!subscriptionsInitialized;

	const isRenderable = featuresLoaded;

	const [isLoading, setIsLoading] = useState<boolean>(isApplicationLoading);
	useEffect(() => {
		if (isApplicationLoading !== isLoading) {
			setIsLoading(isApplicationLoading);
			dispatch(setLoadingAction(isApplicationLoading));
		}
	}, [isApplicationLoading, isInitializing, settingsLoaded, featuresLoaded]);

	return (
		<LoadingContext.Provider value={{ isLoading }}>
			{isRenderable ? (
				children
			) : (
				<UnauthorizedLoadingPage branding={branding} />
			)}
		</LoadingContext.Provider>
	);
};

export default LoadingProvider;
